import { makeStyles } from '@mui/styles';
import theme from 'theme';

const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
        position: 'relative',
    },
    paper: {
        padding: theme.spacing(4),
        borderRadius: 4,
    },

    title: {
        marginBottom: theme.spacing(3),
        paddingBottom: theme.spacing(2),
        borderBottom: `1px solid #E4E4E4`,
    },

    login: {
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        color: 'white',
        width: 'fit-content',
        padding: theme.spacing(3),
        borderRadius: 24,
        cursor: 'pointer',
        background: 'linear-gradient(135deg, #0064C0 0%, #3391D0 100%)',

        '& > h5': {
            maxWidth: 220,
        },
    },
    disabledLogin: {
        background: '#9e9e9e',
    },
    loginIcon: {
        height: 50,
        width: 50,
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        '& > svg': {
            color: theme.palette.primary.main,
            fontSize: 30,
        },
    },
}));

export default useStyles;
